// import { combineReducers } from "redux";
import types from './types';
import produce from 'immer';

import { SAMPLE_TREE, LAYOUTS } from '../constants';

const defaultState = {
  editorValue: SAMPLE_TREE,
  layoutType: LAYOUTS.default
};

const appReducer = produce((draft, action) => { // currying for data last
  switch (action.type) {
    case types.SET_EDITOR_VALUE:
      draft.editorValue = action.payload;
      break;
    case types.SET_LAYOUT_TYPE:
      draft.layoutType = action.payload;
  }
}, defaultState);

export default appReducer;

// Selectors
export const getEditorValue = (state) => state.editorValue;
export const getLayoutType = (state) => state.layoutType;
